export function groupClasses(classes, modules) {
  const groups = modules.map(module => ({ ...module, lessons: [] }));
  const byId = new Map(groups.map(module => [String(module._id), module]));
  const general = { _id: "general", title: "General", lessons: [] };
  for (const lesson of classes) {
    (byId.get(String(lesson.module)) || general).lessons.push(lesson);
  }
  return general.lessons.length ? [general, ...groups] : groups;
}

export function moduleProgress(module, progress) {
  const total = module.lessons.length;
  const completed = module.lessons.filter(lesson => progress[lesson._id]?.completedAt).length;
  return { total, completed, percentage: !total ? 0 : completed === total ? 100 : Math.min(99, Math.round(completed / total * 100)) };
}

export function resumeClass(groups, progress) {
  const lessons = groups.flatMap(module => module.lessons);
  return lessons.find(lesson => !progress[lesson._id]?.completedAt) || lessons[0] || null;
}
